// extracted by mini-css-extract-plugin
var _1 = "CommentContext-module__highlight--CEQRt";
var _2 = "CommentContext-module__image--CRQM_";
export { _1 as "highlight", _2 as "image" }
